import { vektra, admin, personal } from './vektra';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [vektra, admin, personal]
};

export default menuItems;
